// Store all the query keys used in the application here
// by using the same query keys we benefit from SWR's cache
export const GET_BOOKINGS_QUERY_KEY = 'getBookings'
export const GET_CATEGORIES_QUERY_KEY = 'getCategories'
export const GET_CLASSROOM_PLAYLIST_QUERY_KEY = 'getClassroomPlaylist'
export const GET_COLLECTIVE_ACADEMIES = 'getCollectiveAcademies'
export const GET_COLLECTIVE_FAVORITES = 'getCollectiveFavorites'
export const GET_COLLECTIVE_OFFER_QUERY_KEY = 'getCollectiveOffer'
export const GET_COLLECTIVE_OFFER_TEMPLATE_QUERY_KEY =
  'getCollectiveOfferTemplate'
export const GET_COLLECTIVE_OFFER_TEMPLATES_QUERY_KEY =
  'getCollectiveOfferTemplates'
export const GET_COLLECTIVE_OFFER_TEMPLATES_HOME_QUERY_KEY =
  'getCollectiveOfferTemplatesHome'
export const GET_COLLECTIVE_OFFERS_BOOKABLE_QUERY_KEY =
  'getCollectiveOffersBookable'
export const GET_COLLECTIVE_OFFERS_HOME_QUERY_KEY = 'getCollectiveOffersHome'
export const GET_COLLECTIVE_OFFERS_TEMPLATE_QUERY_KEY =
  'getCollectiveOffersTemplate'
export const GET_COLLECTIVE_OFFERS_FOR_INSTITUTION_QUERY_KEY =
  'getCollectiveOffersForMyInstitution'
export const GET_COLLECTIVE_OFFERS_QUERY_KEY = 'getCollectiveOffers'
export const GET_COLLECTIVE_REQUEST_INFORMATIONS_QUERY_KEY =
  'getCollectiveOfferRequestInformations'
export const GET_AUTOCOMPLETE_EDUCATIONAL_REDACTORS_FOR_UAI_KEY =
  'getAutocompleteEducationalRedactorsForUai'
export const GET_EDUCATIONAL_DOMAINS_QUERY_KEY = 'listEducationalDomains'
export const GET_EDUCATIONAL_OFFERERS_QUERY_KEY = 'listEducationalOfferers'
export const GET_EDUCATIONAL_STATUSES_QUERY_KEY = 'getVenuesEducationalStatuses'
export const GET_EDUCATIONAL_INSTITUTION_BUDGET_QUERY_KEY =
  'getEducationalInstitutionWithBudget'
export const GET_EDUCATIONAL_INSTITUTIONS_QUERY_KEY =
  'getEducationalInstitutions'
export const GET_EVENT_PRICE_CATEGORIES_AND_SCHEDULES_BY_DATE_QUERY_KEY =
  'getPriceCategoriesAndSchedulesByDate'
export const GET_FEATURES_QUERY_KEY = 'getFeatures'
export const GET_HAS_BOOKINGS_QUERY_KEY = 'getHasBookings'
export const GET_HAS_INVOICE_QUERY_KEY = 'getHasInvoice'
export const GET_INVOICES_QUERY_KEY = 'getInvoices'
export const GET_HAS_SETTLEMENT_QUERY_KEY = 'getHasSettlement'
export const GET_SETTLEMENTS_QUERY_KEY = 'getSettlements'
export const GET_LOCAL_OFFERERS_PLAYLIST_QUERY_KEY = 'getLocalOfferersPlaylist'
export const GET_NEW_OFFERS_PLAYLIST_KEY = 'getNewOffersPlaylist'
export const GET_MEMBERS_QUERY_KEY = 'getMembers'
export const GET_MUSIC_TYPES_QUERY_KEY = 'getMusicTypes'
export const GET_NEW_OFFERERS_PLAYLIST_QUERY_KEY = 'getNewOfferersPlaylist'
export const GET_NFD_QUERY_KEY = 'getNFD'
export const GET_OFFER_QUERY_KEY = 'getOffer'
export const GET_ACTIVE_VENUE_OFFER_BY_EAN_QUERY_KEY =
  'getActiveVenueOfferByEan'
export const GET_OFFERS_QUERY_KEY = 'listOffers'
export const GET_OFFERS_HOME_QUERY_KEY = 'listOffersHome'
export const GET_OFFERER_BANK_ACCOUNTS_AND_ATTACHED_VENUES_QUERY_KEY =
  'getOffererBankAccountsAndAttachedVenues'
export const GET_REJECTED_BANK_ACCOUNTS_QUERY_KEY = 'getRejectedBankAccounts'
export const GET_VENUE_HEADLINE_OFFER_QUERY_KEY = 'getVenueHeadlineOffer'
export const GET_OFFERER_NAMES_QUERY_KEY = 'getOffererNames'
export const GET_PROVIDERS_QUERY_KEY = 'getProviders'
export const GET_STOCKS_EVENT_STATS_QUERY_KEY = 'getStocksEventStats'
export const GET_STOCKS_QUERY_KEY = 'getStocks'
export const GET_NEXT_STOCK_QUERY_KEY = 'getNextStock'
export const GET_VENUE_QUERY_KEY = 'getVenue'
export const GET_VENUE_ADDRESS_QUERY_KEY = 'getVenueAddresses'
export const GET_VENUES_OF_OFFERER_FROM_SIRET_QUERY_KEY =
  'getVenuesOfOffererFromSiret'
export const GET_VENUE_PROVIDERS_QUERY_KEY = 'getVenueProviders'
export const GET_VENUES_STATS_QUERY_KEY = 'getVenueOffersStats'
export const GET_VENUES_OFFERS_STATS_V2 = 'getVenueOffersStatsV2'
export const LOG_CATALOG_VIEW_QUERY_KEY = 'logCatalogView'
export const LOG_TRACKING_FILTER_QUERY_KEY = 'logTrackingFilter'
export const GET_STATISTICS_QUERY_KEY = 'getStatistics'
export const GET_HIGHLIGHTS_QUERY_KEY = 'getHighlights'
export const GET_PRO_ANONYMIZATION_ELIGIBILITY_QUERY_KEY =
  'getProAnonymizationEligibility'
export const GET_USER_EMAIL_PENDING_VALIDATION = 'getUserEmailPendingValidation'
export const GET_OFFER_EXPOSURE_QUERY_KEY = 'getOfferExposure'
export const GET_AUTHENTICATED_ADAGE_USER = 'getAuthenticatedAdageUser'
